import styled from 'styled-components/macro';

const IconWrapper = styled.div`
  position: absolute;
  top: 8px;
  right: 2px;
  opacity: 0.6;
  font-size: 16px;
`;

export default IconWrapper;
